<template>
  <Custom-Select
    v-model="list"
    :label="label"
    :items="callTypes"
    multiple
  />
</template>


<script>
export default {
  name: 'CallsType',
  props: {
    value: {
      required: true,
    },
    label: {
      type: String,
      default: 'Тип звонка',
    },
  },

  data() {
    return {
      callTypes: [
        {id: 'incoming', name: 'Входящие'},
        {id: 'outgoing', name: 'Исходящие'},
        {id: 'outbound', name: 'Кампании'},
      ],
    }
  },

  computed: {
    list: {
      get() {
        return this.value
      },
      set(item) {
        this.$emit('input', item)
      },
    },
  },
}
</script>